import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { FileDown } from 'lucide-react';
import { PageHead } from '../organization/finance/shared';
import CoachProfileBasicsTab from './CoachProfileBasicsTab';
import CoachProfilePrivacyTab from './CoachProfilePrivacyTab';
import CoachCertificationsTab from './CoachCertificationsTab';
import CoachExperiencesTab from './CoachExperiencesTab';
import CvStudioModal from './cv/CvStudioModal';

const TABS = [
  { key: 'basics', label: 'البيانات الأساسية' },
  { key: 'certifications', label: 'الشهادات والرخص' },
  { key: 'experiences', label: 'الخبرات' },
  { key: 'privacy', label: 'الخصوصية والظهور' },
];

export default function CoachProfilePage() {
  const { profile, refreshProfile } = useOutletContext() || {};
  const [tab, setTab] = useState('basics');
  const [studio, setStudio] = useState(false);

  return (
    <div className="space-y-6" data-testid="coach-profile-page">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <PageHead title="ملفي المهني" desc="بيانات ملفك يملكها أنت، وتنتقل معك بين المنشآت" />
        <button onClick={() => setStudio(true)} disabled={!profile} className="inline-flex items-center gap-2 rounded-xl border border-teal-200 bg-teal-50 px-4 py-2.5 text-sm font-bold text-teal-700 shadow-[0_1px_3px_rgba(0,0,0,0.04)] transition-all hover:border-teal-300 active:scale-95 disabled:opacity-50" data-testid="coach-download-cv-btn">
          <FileDown size={16} /> استوديو السيرة الذاتية
        </button>
      </div>

      <div className="flex gap-1.5 overflow-x-auto rounded-2xl border border-slate-200/70 bg-white p-1.5 shadow-[0_1px_3px_rgba(0,0,0,0.04)]">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            data-testid={`coach-profile-tab-${t.key}`}
            className={`whitespace-nowrap rounded-xl px-4 py-2.5 text-sm font-bold transition-all active:scale-95 ${tab === t.key ? 'bg-gradient-to-br from-teal-500 to-emerald-600 text-white shadow-md shadow-teal-500/20' : 'text-slate-500 hover:bg-slate-50'}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'basics' && <CoachProfileBasicsTab profile={profile} refreshProfile={refreshProfile} />}
      {tab === 'privacy' && <CoachProfilePrivacyTab profile={profile} refreshProfile={refreshProfile} />}
      {tab === 'certifications' && <CoachCertificationsTab />}
      {tab === 'experiences' && <CoachExperiencesTab />}

      <CvStudioModal open={studio} onClose={() => setStudio(false)} profile={profile} />
    </div>
  );
}
